/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './deleteMember.defs.js'
export { main as default } from './deleteMember.defs.js'
